/**
 * Date formatting utilities
 *
 * Formats dates with time and timezone information to match legacy admin display
 */

/**
 * Formats a date string to include time and timezone
 * Format: "2013-05-24 4:28PM -0400" (matches old admin format)
 *
 * @param dateString - ISO date string or date string
 * @returns Formatted date string with time and timezone
 *
 * @example
 * ```typescript
 * formatDateWithTimezone('2013-05-24T16:28:00-04:00')
 * // Returns "05/24/2013, 4:28 PM EDT" (or similar based on locale)
 * ```
 */
export const formatDateWithTimezone = (dateString: string): string => {
  if (!dateString) {
    return '-';
  }

  try {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return '-';
    }

    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short',
    };

    return date.toLocaleString('en-US', options);
  } catch (error) {
    console.error('Error formatting date:', error);
    return '-';
  }
};
